module.exports = __webpack_public_path__ + "static/media/YF83_5.b7d5873d.jpg";